// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-7be0959b] .v-skeleton-loader>*{height:100%;display:flex;flex-direction:column}[data-v-7be0959b] .v-skeleton-loader .v-skeleton-loader__bone{flex-grow:1}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
